import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InvoiceAdvancedSearchService } from './invoice-advanced-search.service';

@Component({
	selector: 'app-invoice',
	templateUrl: './invoice.component.html',
	styleUrls: [ './invoice.component.scss' ]
})
export class InvoiceComponent implements OnInit {
	activeRoute = '';
	constructor(
		private invoiceAdvancedSearch: InvoiceAdvancedSearchService,
		private location: Location,
		private router: Router
	) {}

	ngOnInit(): void {
		let url = this.location.path();
		this.activeRoute = url.split('/').pop();
		this.router.events.subscribe(() => {
			let url: any = this.location.path();
    		this.activeRoute = url.split('/').pop();
		})
	}

	toggleAdvancedSearch() {
		this.invoiceAdvancedSearch.toggleSearch.emit(this.activeRoute);
	}

	exportSearch() {
		this.invoiceAdvancedSearch.exportSearch.emit(this.activeRoute);
	}

	goBack() {}
}
